import {
    CONFIRM_MODAL,
    CONFIRM_MODAL_SUCCESS,
    CONFIRM_MODAL_FAIL,
    CONFIRM_MODAL_RESET,
    CONFIRM_MODAL_SET_PARAMS
} from './constants';

// ========================================================
// 移除
// ========================================================
export const confirmModalReset = () => ({
    type: CONFIRM_MODAL_RESET,
    payload: null,
});
export const confirmModalSetParams = ({params}) => ({
    type: CONFIRM_MODAL_SET_PARAMS,
    payload: {params},
});
export const confirmModal = ({params}) => ({
    type: CONFIRM_MODAL,
    payload: {params},
});
export const confirmModalSuccess = (data) => ({
    type: CONFIRM_MODAL_SUCCESS,
    payload: data,
});
export const confirmModalFail = (data) => ({
    type: CONFIRM_MODAL_FAIL,
    payload: data,
});